import queryString from 'query-string';

import { awsConfig } from '@config';

/**
 * Builds the Cognito Hosted-UI logout URL.
 *
 * Federated logins (SAML SSO / Google social) go through the Cognito Hosted UI,
 * which sets its own ~1h session cookie on the Cognito domain. Revoking our
 * refresh token on logout does NOT clear that cookie, so the next
 * `federatedSignIn` within the hour silently reuses the Cognito session without
 * re-consulting the upstream IdP. Redirecting the browser through this endpoint
 * clears the Hosted-UI cookie so the next login is forced back to the IdP.
 *
 * `logout_uri` reuses `redirectSignOut` (already registered as an allowed
 * sign-out URL in the Cognito app client) so no Cognito config change is needed.
 *
 * Returns an empty string when the Cognito domain is not configured (local dev
 * / `disableCognito`), so callers can skip the redirect and fall back to the
 * normal in-app logout.
 */
export function buildCognitoLogoutUrl(): string {
  const { domain, redirectSignOut } = awsConfig.Auth.oauth;
  const clientId = awsConfig.Auth.userPoolWebClientId;

  if (!domain) {
    return '';
  }

  const params = queryString.stringify({
    client_id: clientId,
    logout_uri: redirectSignOut,
  });

  return `https://${domain}/logout?${params}`;
}
